import { render } from "./CareReviewPage.vue?vue&type=template&id=aabfe554&scoped=true"
import script from "./CareReviewPage.vue?vue&type=script&lang=js"
export * from "./CareReviewPage.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "./CareReviewPage.vue?vue&type=style&index=1&id=aabfe554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aabfe554"]])

export default __exports__